import type { GridColumnsInput } from '@thinkalpha/ui-table/types/column';
export const eventsGridColumns: GridColumnsInput = {
    columns: ['symbol', 'event', 'details'].map((columnId) => ({ columnId, fieldId: 'event', hostedRenderer: true })),
    columnState: [
        { columnId: 'symbol', order: 0, visible: true, width: 60, pinned: 'left' },
        { columnId: 'event', order: 1, visible: true, width: 120 },
        { columnId: 'details', order: 2, visible: true, width: 500 },
    ],
    columnDisplay: [
        { columnId: 'symbol', label: 'Symbol', displaySettings: [] },
        { columnId: 'event', label: 'Event', displaySettings: [] },
        { columnId: 'details', label: 'Details', displaySettings: [], ellipsis: true },
    ],
};
